import BaseModel from 'src/model/base.model';
import LocationModel from './location.model';

export interface ISubItem {
  description: string;
  imageURL: string;
  manufacturer: string;
  partnerPrice: string;
  productNumber: string;
  quantity: number;
  totalAmount: number;
}

export class CartItemModel extends BaseModel {
  public amountInStock: number;
  public state: string;
  public claims: string = '';
  public description: string;
  public id: number;
  public image: string;
  public itemTotal: number;
  public manufacturer: string = '';
  public manufacturerCode: string;
  public name: string;
  public productNumber: string;
  public quantity: number;
  public shipmentMarking: string = '';
  public shipsfrom: LocationModel;
  public shipsfromCode: string;
  public subItems: ISubItem[] = [];
  public unitPrice: number;
  public warrantyProvider: string = '';
  public rushOrder: boolean = false;
  public ticketNumber: string = '';
  public specialOrder: boolean = false;
  public isDropShip: boolean = false;
  public replacementMfc: string;
  public replacementPart: string;
  public alternateProductNumber: string;
  public alternateProductManufacturer: string;
  public oemProductNumber: string;
  public oemProductManufacturer: string;
}

export default CartItemModel;
